export const forceRevokeModalStyles = {
  contentContainer: {
    width: '500px',
    p: 1,
    m: 1,
  },
  entitiesContainer: { display: 'flex', flexDirection: 'column', ml: 3 },
  revokeButton: { mr: 1 },
};
